module.exports = __webpack_public_path__ + "img/subbie.0839c369.jpg";